import { jsonldAddressRegion } from './JsonldStore';

export const updateJsonldAddressRegion = (value) => jsonldAddressRegion.update((oldValue) => value);
